import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import carouSellAutosLogo from '_images/carousell-autos-logo.svg';
import getQuoteBannerBg from '_images/get-quote-banner-bg.png';
import osLogo from '_images/oneshift-logo-colour.png';

export default function GetQuoteBanner({ className, utmMedium }) {
  return (
    <div
      className={classNames(
        'hidden sm:block px-10 py-8 xl:pl-16 xl:py-14 bg-os-light-blue-25 rounded-lg relative overflow-hidden',
        className,
      )}
    >
      <div className="absolute inset-0">
        <img
          src={getQuoteBannerBg}
          alt="get quote bg"
          className="w-full h-full object-cover z-10"
        />
      </div>
      <div className="w-[54%] z-20 relative">
        <img
          src={osLogo}
          alt="OneShift"
          className="h-[21px] xl:h-24 -ml-12"
        />
        <div className="font-bold text-2xl leading-8 xl:text-4.2xl xl:leading-11 mt-2.5 xl:mt-4 text-conent-primary">
          Sell your car at the highest price in Singapore
        </div>
        <p className="mt-1 xl:mt-2 mb-0 flex flex-col gap-y-2 text-base xl:text-2xl text-content-secondary">
          Get the Best Price for your used car <br /> from 500+ dealers in 24
          hours
        </p>
        <div className="mt-4">
          <Link
            to={`/sell-my-car-online-to-dealer-singapore/?utm_source=os-organic&utm_medium=${utmMedium}&utm_campaign=rect-s2c`}
            className="bg-caroured50 text-white hover:text-white py-2.5 xl:py-3 rounded text-xs xl:text-base w-[127px] xl:w-[152px] font-bold inline-block text-center"
          >
            Get Quote
          </Link>
        </div>
      </div>
    </div>
  );
}
